import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

// It is possible for a member's status to be 'Active' and the memberType to be 'NonMember' OR 'Prospect'
// it is an edge case and it won't be taken into account as discussed is meeting on 11/4/2021 pre launch
// of properties, connections, messaging.
// A hook may seem overly complex for this, but the criteria could change in the future
const useIsMemberActiveMember = ({ status }) => {
    const [isMemberActive, setIsMemberActive] = useState(false);

    useEffect(() => {
        if (!status) return;
        setIsMemberActive(status === 'Active');
    }, [status]);

    return isMemberActive;
};

useIsMemberActiveMember.propTypes = {
    status: PropTypes.string,
};

export default useIsMemberActiveMember;
